import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import BusinessLanding from "@/pages/BusinessLanding";
import AdminRoutes from "@/admin/AdminRoutes";
import PublicConfigurator from "@/admin/PublicConfigurator";
import AffiliateBridge from "@/admin/AffiliateBridge";
import ReservationConfirmation from "@/admin/ReservationConfirmation";
import EscapadaDetail from "@/pages/EscapadaDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BusinessLanding />} />
          {/* Admin (login + dashboard + editor) */}
          <Route path="/admin/*" element={<AdminRoutes />} />
          {/* Public proposal share link — interactive configurator */}
          <Route path="/p/:token" element={<PublicConfigurator />} />
          {/* Affiliate redirect bridge — branded 1.5s intermediate page */}
          <Route path="/go" element={<AffiliateBridge />} />
          {/* Reservation confirmation — premium intermediate page for booking mode */}
          <Route path="/reserva/:token" element={<ReservationConfirmation />} />
          {/* Escapadas Low Cost editorial pages */}
          <Route path="/escapadas/:slug" element={<EscapadaDetail />} />
          {/* Legacy redirects */}
          <Route path="/moments" element={<Navigate to="/" replace />} />
          <Route path="/business" element={<Navigate to="/" replace />} />
          <Route path="/sigean" element={<Navigate to="/" replace />} />
          <Route path="/roma-1-dia" element={<Navigate to="/" replace />} />
          <Route path="/milan-lago-como" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
